import { useMediaProps } from '@zapier/responsive-utils';

type SizeType = 'small' | 'medium' | 'large';

const desktop = '(min-width: 1024px)';
const tablet = '(min-width: 660px) and (max-width: 1023px)';

function useSize(): SizeType {
  return useMediaProps({
    all: {
      size: 'small',
    },
    [desktop]: { size: 'large' },
    [tablet]: { size: 'medium' },
  }).size;
}

export default useSize;
